"use client";
import { ENTERPRISE_PLAN_URL } from "@workspace/core/constants";
import { SubscriptionPlan } from "@workspace/types";
import { Plans } from "@workspace/ui/common";
import { useRouter } from "next/navigation";

export const SubscriptionManager = () => {
  const router = useRouter();
  const handleSubscribe = (plan: SubscriptionPlan) => {
    if (plan === "enterprise") {
      return router.push(ENTERPRISE_PLAN_URL);
    }
    router.push("/auth");
  };
  return (
    <Plans
      isLoading={false}
      variant="primary"
      ready={true}
      onUnsubscribe={() => handleSubscribe("free")}
      onSubscribe={handleSubscribe}
    />
  );
};
